module.exports = __webpack_public_path__ + "static/media/clue-8.b61f90e8.svg";